import {styled} from "@mui/material";

export const AdditionalServiceContainer = styled('div')(({theme}) => ({
    width: '16rem',
    height: '9.25rem',
    borderRadius: '0.5rem',
    border: `1px solid ${theme.barekam.additionalService.border.default}`,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',

    '&:hover': {
        background: theme.barekam.additionalService.background.hover
    }
}));
export const AdditionalServiceContainerSelected = styled(AdditionalServiceContainer)(({theme}) => ({
    border: `1px solid ${theme.barekam.additionalService.border.selected}`,
}));

export const AdditionalServiceSlimContainer = styled('div')(({theme}) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    border: `1px solid #F1F1FB`,

    '&:hover': {
        background: theme.barekam.grey
    }
}));
export const AdditionalServiceContainerSlimSelected = styled(AdditionalServiceSlimContainer)(({theme}) => ({
    border: `0.15rem solid ${theme.barekam.green}`,
    padding: '0.35rem 0.90rem',
}));

export const NameContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden'
    }
});

export const ServiceTitleContainer = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        gap: '0.5rem'
    }
});

export const CountContainer = styled('div')(() => {
    return {
        width: '100%',
        height: '100%',
        padding: '0.1rem 0.25rem 0.1rem 0.25rem',
        gap: '0.5rem',
        borderRadius: '0.5rem',
        backgroundColor: '#DA1944',
        color: 'white'
    }
});

export const AdditionalServiceWarehouseCardContainer = styled(AdditionalServiceContainer)(({theme}) => ({
    border: `unset`,
}));
